
import { useRoute } from 'vue-router'
import { ref, onBeforeMount } from 'vue'
import { getOfficialSheetSongInfo, getPersonalSheetSongInfo } from '@/services/songs'
import config from '@/config'
import { songType, songSheetType } from '@/utils/dataMap/song'

export default {
  name: 'Detail',
  setup () {
    const route = useRoute()
    const formState = ref({
      song_type: 0,
      sheet_type: 0,
      tags: []
    })
    onBeforeMount(async () => {
      const getInfo = route.params.type === '1' ? getOfficialSheetSongInfo : getPersonalSheetSongInfo
      formState.value = await getInfo(route.params.id)
    })

    return {
      history,
      formState,
      config,
      songType,
      songSheetType
    }
  }
}
